import { IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { Check, Clear } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { APICallStatus, DataTypes, VisitorParkingRequest, VisitorParkingRequestStatus } from "../../Types/UnitFeatureTypes";
import { Actions } from "../../Redux/Reducer/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../context/authContext";
import { approveVisitorParkingAPIStatus, statusUpdateVisitorParkingAPIStatus } from "../../Redux/selectors";
import { useEffect } from "react";
import { useApp } from "../../context/appContext";

interface BuildVisitorParkingTableProps {
    item: VisitorParkingRequest[];
    showActions?: boolean;
}

const BuildVisitorParkingTable: React.FC<BuildVisitorParkingTableProps> = ({
    item,
    showActions = true
}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useAuth();
    const approveStatus = useSelector(approveVisitorParkingAPIStatus);
    const statusUpdate = useSelector(statusUpdateVisitorParkingAPIStatus);
    const { setSnackbar } = useApp();

    useEffect(() => {
        if (approveStatus === APICallStatus.SUCCESS || statusUpdate === APICallStatus.SUCCESS) {
            dispatch(Actions.fetchVisitorParking.visitorParkingActions.request({}));
            setSnackbar(true, 'Visitor parking updated successfully', 'success');
            
        } else if (approveStatus === APICallStatus.FAILURE || statusUpdate === APICallStatus.FAILURE) {
            setSnackbar(true, 'Failed to approve visitor parking request', 'error');
        } 
        // else if () {
        //     alert("Failed to reject visitor parking request");
        // }
        dispatch(Actions.visitorParking.resetStatusRequestAction());
    }, [approveStatus, statusUpdate])

    const getTableData = (item: VisitorParkingRequest[]) => {
        return (<Table>
            <TableHead>
                <TableRow>
                    <TableCell sx={{fontWeight: 600}} align="center">Parking Start</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Parking End</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Car</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">License Plate</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Unit</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Status</TableCell>
                    {showActions && <TableCell sx={{fontWeight: 600}} align="center">Quick Actions</TableCell>}
                </TableRow>
            </TableHead>
            <TableBody>
                {item.map((parkingRequest: VisitorParkingRequest) => {
                    const isInPast = new Date(parkingRequest.date_requested.end) < new Date();
                    return (
                    <TableRow key={parkingRequest.id} 
                    // sx={{'&:hover': {backgroundColor: '#f5f5f5',cursor: 'pointer'}}} 
                    onClick={(e) => {
                        if ((e.target as HTMLElement).closest('#actions')) return;
                        // handleBookingExpanded(parkingRequest.id)
                    }}>
                        <TableCell sx={{maxWidth: 400}} align="center">
                            <Tooltip title={new Date(parkingRequest.date_requested.start).toDateString()}>
                                <Typography variant="body2" color="textSecondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {new Date(parkingRequest.date_requested.start).toDateString()}
                                </Typography>
                            </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                            <Typography variant="body2" color="textSecondary">{new Date(parkingRequest.date_requested.end).toDateString()}</Typography>
                        </TableCell>
                        <TableCell sx={{maxWidth: 100}} align="center">
                            <Tooltip title={`${parkingRequest.car.color} ${parkingRequest.car.make} ${parkingRequest.car.model}`}>
                                <Typography variant="body2" color="textSecondary" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {parkingRequest.car.make} {parkingRequest.car.model} - {parkingRequest.car.color}
                                </Typography>
                            </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                            <Typography variant="body2" color="textSecondary">{parkingRequest.car.plate}</Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography variant="body2" color="textSecondary">{parkingRequest.visitor_unit}</Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography variant="body2" color="textSecondary">{parkingRequest.status}</Typography>
                        </TableCell>
                        {showActions && (parkingRequest.status === VisitorParkingRequestStatus.PENDING && !isInPast? <TableCell align="center" id="actions">
                            <Tooltip title="Approve Request">
                                <IconButton onClick={() => handleApproveVisitorParking(parkingRequest.id)}><Check /></IconButton> 
                            </Tooltip>
                            <Tooltip title="Reject Request">
                                <IconButton onClick={() => handleRejectBooking(parkingRequest.id)}><Clear /></IconButton> 
                            </Tooltip>
                        </TableCell>: <TableCell align="center"/>)}
                    </TableRow>
                    )}
                )}
            </TableBody>
        </Table>)
    }

    if (!item.length) {
        return (
            <Paper elevation={3} sx={{borderRadius: 3, padding: 2, alignItems: 'center', display: 'flex', justifyContent: 'center'}}>
                <Typography variant="subtitle1" fontWeight={600} color="textSecondary">No Visitor Parking Booked</Typography>
            </Paper>
        )
    }

    const handleBookingExpanded = (id?: number) => {
        if (!id) return;
        navigate(`/viewVisitorParking`, { state: { id, type: DataTypes.VISITOR_PARKING } });
    }

    const handleApproveVisitorParking = (id?: number) => {
        if (!id) return;
        dispatch(Actions.visitorParking.approveVisitorParkingRequestAction.request({ 
            id,
            approval_date: new Date(),
            approved_by: user.id
         }));
    }
    const handleRejectBooking = (id?: number) => {
        if (!id) return;
        dispatch(Actions.visitorParking.statusUpdateVisitorParkingRequestAction.request({ 
            id,
            status: VisitorParkingRequestStatus.REJECTED
         }));
    }

    return (
        <Paper elevation={3} sx={{borderRadius: 3, overflow: 'auto'}}>
            {getTableData(item)}
        </Paper>
    )
}

export default BuildVisitorParkingTable;